/**
   * @ngdoc directive
   * @name adjust.directive:scrollTrigger
   * @scope
   * @restrict A
   *
   * @description
   * For particular areas like header and footer it's not possible to scroll naturally, so it needs to be triggered manually
   *
   */
function scrollTrigger(Helper) {
  'ngInject';
  return {
    restrict: 'A',
    scope: {},
    require: ['scrollTrigger', '^scrollTable'],
    controller: 'ScrollTriggerController',
    controllerAs: 'vm',
    link: Helper.linkFunction
  };
}

/**
   * @ngdoc controller
   * @name adjust.controller:ScrollTriggerController
   *
   * @description
   * All the functionality of the {@link adjust.directive:scrollTrigger scrollTrigger} directive
   *
   */
function ScrollTriggerController($element) {
  'ngInject';
  var vm = this;

  vm.init = init;

  $element.bind('wheel', _handleWheel);

  /**
   * @ngdoc method
   * @name init
   * @methodOf adjust.controller:ScrollTriggerController
   *
   * @description
   * Register parent controller
   *
   * @param {Object} parentController parent controller
   */
  function init(parentController) {

    vm.parentController = parentController;

  }

  /**
   * @ngdoc method
   * @name _handleWheel
   * @methodOf adjust.controller:ScrollTriggerController
   *
   * @description
   * Handle wheel event
   *
   * @param {Object} e wheel event object
   * @private
   */
  function _handleWheel(e) {

    vm.parentController.initScroll(e.deltaX);

  }
}
export { ScrollTriggerController, scrollTrigger };
